"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const url = __importStar(require("url"));
const Y = __importStar(require("yahoo"));
const types = __importStar(require("./types"));
const actions = __importStar(require("./actions"));
class MapManageer {
    constructor() {
        this.CENTER = new Y.LatLng(36.92374740858853, 139.86856887304685);
        this.DEFAULT_ZOOM = 11;
        this.currentInfoWindow = null;
        this.markers = new Map();
        this.middleware = (store) => (next) => (action) => __awaiter(this, void 0, void 0, function* () {
            switch (action.type) {
                case types.INIT:
                    this.init(next, store);
                    break;
                case types.ADD_SPOT:
                    this.addSpot(action);
                    next(action);
                    break;
                case types.PAN_TO:
                    this.panTo(action);
                    next(action);
                    break;
                case types.FILTER:
                    next(action);
                    this.syncMarkerVisibility(store.getState().spots);
                    break;
                case types.RESET:
                    this.resetMap();
                    next(action);
                    this.syncMarkerVisibility(store.getState().spots);
                    break;
                default:
                    next(action);
                    break;
            }
        });
        this.addSpot = (action) => {
            if (this.ymap === undefined) {
                throw new Error();
            }
            const spot = action.payload.spot;
            const latLng = new Y.LatLng(spot.lat, spot.lng);
            const marker = new Y.Marker(latLng);
            const anchor = document.createElement("a");
            anchor.text = spot.name;
            anchor.href = spot.url;
            anchor.target = "_blank";
            marker.bind("click", () => {
                this.currentInfoWindow = marker.openInfoWindow(anchor);
            });
            this.markers.set(spot.name, { marker, anchor });
            this.ymap.addFeature(marker);
        };
        this.removeAllMarker = () => {
            if (this.ymap === undefined) {
                throw new Error();
            }
            for (const { marker } of this.markers.values()) {
                this.ymap.removeFeature(marker);
            }
        };
        this.syncMarkerVisibility = (spots) => {
            this.removeAllMarker();
            if (this.ymap === undefined) {
                throw new Error();
            }
            for (const spot of spots) {
                const { name, visible } = spot;
                if (visible) {
                    const value = this.markers.get(name);
                    if (value) {
                        this.ymap.addFeature(value.marker);
                    }
                }
            }
        };
        this.panTo = (action) => {
            if (this.ymap === undefined) {
                throw new Error();
            }
            const spot = action.payload.spot;
            const latLng = new Y.LatLng(spot.lat, spot.lng);
            this.ymap.panTo(latLng, true);
            this.ymap.setZoom(13, true, latLng, true);
            const result = this.markers.get(spot.name);
            if (result) {
                this.currentInfoWindow = result.marker.openInfoWindow(result.anchor);
            }
        };
        this.resetMap = () => {
            if (this.ymap === undefined) {
                throw new Error();
            }
            this.ymap.panTo(this.CENTER, true);
            this.ymap.setZoom(11, true, this.CENTER, true);
            if (this.currentInfoWindow) {
                this.currentInfoWindow.hide();
            }
        };
        this.init = (_, store) => __awaiter(this, void 0, void 0, function* () {
            this.ymap = new Y.Map("map", { configure: {
                    doubleClickZoom: true,
                    dragging: true,
                } });
            this.ymap.addControl(new Y.LayerSetControl());
            this.ymap.addControl(new Y.SliderZoomControlVertical());
            this.ymap.addControl(new Y.ScaleControl());
            this.ymap.drawMap(this.CENTER, this.DEFAULT_ZOOM, Y.LayerSetId.NORMAL);
            this.ymap.bind("click", () => store.dispatch(actions.reset()));
            const baseUrl = location.href;
            const targetUrl = url.resolve(baseUrl, "data/spot.json");
            const resp = yield fetch(targetUrl);
            const result = (yield resp.json());
            for (const spot of result) {
                store.dispatch(actions.addSpot(spot));
            }
        });
    }
}
exports.MapManageer = MapManageer;
